// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';

import classNames from 'classnames';

import Notify from '../../utils/Notify';

import TextInput from './TextInput';

export default class OptionsList extends Component {

  static defaultProps = {
    disabled: false,

    addLabel: I18n.tr('global.add'),

    max: 0,
  };

  static propTypes = {
    /**
     * Array of { label, value }
     */
    list: PropTypes.array.isRequired,

    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool,

    addLabel: PropTypes.func,

  /*
   * The maximum number of values
   */
    max: PropTypes.number,

    /**
     * The `max` chars to set on the `TextInput`
     */
    maxChars: PropTypes.number,
  };

  get list(): Array<string> {
    return this.props.list;
  }

  onAddClicked = () => {
    let list = this.list;

    list.push({
      label: '',
      value: null,
    });

    this.props.onChange(list);
  };

  onChange = (text: string, index) => {
    const list: SelectOptions = this.list;

    list[index].label = text;

    this.props.onChange(list);
  };

  onDelete = (index) => {
    const list = this.list;
    const textToDelete = list[index];

    if (textToDelete.length === 0) { // empty, delete it without asking confirmation
      list.splice(index, 1);
      this.props.onChange(list);
    } else {
      Notify.confirmDelete(I18n.tr('global.are_you_sure'),
       (result) => {
        if (result) {
          list.splice(index, 1);
          this.props.onChange(list);
        }
      });
    }
  };

  //
  // Renderers
  //

  renderList(list: Array<string>) {
    const listView = [];

    _.each(list, (option: SelectOption, index) => {
      listView.push(
        <div
          className="input-group"
          style={style.listItem}
          key={index}
        >
          <TextInput
            key={index}
            className="form-control"
            value={option.label}
            onChange={(text: string) => { this.onChange(text, index); }}
            disabled={this.props.disabled}
            max={this.props.maxChars}
          />

          <div className="input-group-addon">
            {!this.props.disabled &&
              <i
                className="fa fa-trash pointer"
                onClick={() => { this.onDelete(index); }}
              />
            }
          </div>
        </div>
      );
    });

    return (listView);
  }

  render() {
    try {
    return (
      <div className="texts_list">
        {this.renderList(this.list)}

        {!this.props.disabled && this.props.max !== 0 && this.list.length <= this.props.max &&
          <div
            style={style.link}
            className="link"
            onClick={this.onAddClicked}
          >
            {this.props.addLabel}
          </div>
        }
      </div>
    );
   } catch (e) { console.error(e); }
  }

}

const style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/OptionsList.js